import { css } from "@emotion/react";

export const margin = (size: number) => css(`margin: ${size}px;`);

export const marginTop = (size: number) => css(`margin-top: ${size}px;`);

export const marginBottom = (size: number) => css(`margin-bottom: ${size}px;`);

export const marginLeft = (size: number) => css(`margin-left: ${size}px;`);

export const marginRight = (size: number) => css(`margin-right: ${size}px;`);
